import { render, staticRenderFns } from "./ModalPreviewPhoto.vue?vue&type=template&id=0cb3966c&scoped=true&"
import script from "./ModalPreviewPhoto.vue?vue&type=script&lang=js&"
export * from "./ModalPreviewPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb3966c",
  null
  
)

export default component.exports